import { OverlayPanel } from "primereact/overlaypanel";
import styles from "./index.module.scss";
import { Tooltip } from "primereact/tooltip";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Sidebar } from "primereact/sidebar";

export default function CopyLink({
  op,
  isMobile,
  setVisibleShare,
  visibleShare,
  externalShareLink,
  internalShareLink,
  propertyId
}: {
  op?: any;
  setVisibleShare?: any;
  visibleShare?: any;
  externalShareLink?: any;
  internalShareLink?: any;
  propertyId?: string;
  isMobile?: boolean;
}) {
  const queryClient = useQueryClient();
  const data: any = queryClient.getQueryData(["Property-Detail", propertyId]);
  const [message, setMessage] = useState("Click to Copy");

  const copyLink = (shareLink: string) => {
    navigator.clipboard.writeText(shareLink);
    setMessage("Link Copied!");
    setTimeout(() => {
      setMessage("Click to Copy");
    }, 1000);
  };

  const renderShareOptions = () => (
    <>
      <div className={styles.itemWrap}>
        <div className={styles.subWrap}>
          <div className={styles.itemHeader}>
            {data?.shareLink[0]?.type || "Internal"} Share
          </div>
          {/* <div className={styles.itemDes}>
            Some detail about what internal share is {!isMobile && <br />} used for...
          </div> */}
        </div>
        <Tooltip
          target=".copy-link_copyButton__VASUd"
          className={styles.tooltip}
          content={message}
        />
        <div
          className={styles.copyButton}
          onClick={() => copyLink(internalShareLink?.shareLink)}
        >
          Copy Link{" "}
          <img src="/images/copy-link.svg" alt="" width={18} height={18} />
        </div>
      </div>
      <div className={styles.itemWrap}>
        <div className={styles.subWrap}>
          <div className={styles.itemHeader}>External Share</div>
          {/* <div className={styles.itemDes}>
            Some detail about what external share is {!isMobile && <br />} used for...
          </div> */}
        </div>
        <Tooltip
          target=".copy-link_copyButton__VASUd"
          className={styles.tooltip}
          content={message}
        />
        <div
          className={styles.copyButton}
          onClick={() => copyLink(externalShareLink?.shareLink)}
        >
          Copy Link{" "}
          <img src="/images/copy-link.svg" alt="" width={18} height={18} />
        </div>
      </div>
    </>
  );

  return isMobile ? (
    <Sidebar
      visible={visibleShare}
      position="bottom"
      onHide={() => setVisibleShare(false)}
      className={styles.dialog}
    >
      <div className={styles.header}>Share Property</div>
      {renderShareOptions()}
    </Sidebar>
  ) : (
    // Render OverlayPanel for desktop view
    <OverlayPanel ref={op} closeOnEscape dismissable className={styles.dialog}>
      <div className={styles.header}>Share Property</div>
      {renderShareOptions()}
    </OverlayPanel>
  );
}
